import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { State } from './store.state';
import * as Actions from './store.actions';
import * as RouterStore from '@app/core/services/router/store';
import * as AnnouncementStore from '@app/modules/features/modules/communication/modules/announcements/store';
import * as MessageStore from '@app/modules/features/modules/communication/modules/messages/store';
import * as UserStore from '@app/store/user/user.reducer';
import * as InboxStore from '@app/store/inbox/inbox.reducer';
import * as WellnessStore from '@app/modules/features/modules/wellness/store';
import * as TasksStore from '@app/modules/features/modules/tasks/store';
import * as PubNubStore from '@app/store/pubnub';
import { routerReducer } from '@ngrx/router-store';
import { shiftSwapReducer } from '@app/modules/features/modules/shift-swap/store/shift-swap.reducer';

export function onClearState(
  reducer: ActionReducer<State>,
): ActionReducer<State> {
  return (state, action) => {
    if (action.type === Actions.clearState().type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const reducers: ActionReducerMap<State> = {
  announcementState: AnnouncementStore.reducer,
  messageState: MessageStore.reducer,
  routeRedirectState: RouterStore.reducer,
  userState: UserStore.reducer,
  inboxState: InboxStore.reducer,
  wellnessState: WellnessStore.reducer,
  tasksState: TasksStore.reducer,
  pubNubState: PubNubStore.reducer,
  routerState: routerReducer,
  shiftSwapState: shiftSwapReducer,
};

export const metaReducers: MetaReducer<State>[] = [onClearState];
